import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import '@loyal_template/cart.css'
import '@loyal_template/recharge.css'
import { ResumeRecharge } from './ResumeRecharge'
import { SelectOperator } from './SelectOperator'
import { ValuesRecharge } from './ValuesRecharge'
import { PhoneNumber } from './PhoneNumber'
import { ScheduleRecharge } from './ScheduleRecharge'
import AlertErrorMessage from './AlertErrorMessage'
import { ModalTerms } from './ModalTerms'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import { CellphonerechargePlaceholder } from './'
import constants from './constants'
import { ModalConfirmRecharge } from './ModalConfirmRecharge/index'
import yn from 'yn'
import { SecondFactorAuthentication } from '../Checkout/SecondFactorAuthenticaton'

class Cellphonerecharge extends Component {
  constructor (props) {
    super(props)
    this.onSelectOperatorChange = this.onSelectOperatorChange.bind(this)
    this.onChangeAreaCode = this.onChangeAreaCode.bind(this)
    this.finalizeOrder = this.finalizeOrder.bind(this)
    this.onChangeCreditValue = this.onChangeCreditValue.bind(this)
    this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this)
    this.showTerms = this.showTerms.bind(this)
    this.acceptTerms = this.acceptTerms.bind(this)
    this.onChangeEndDate = this.onChangeEndDate.bind(this)
    this.onChangeInnitialDate = this.onChangeInnitialDate.bind(this)
    this.onChangeScheduleOrder = this.onChangeScheduleOrder.bind(this)
    this.clearErrorMessage = this.clearErrorMessage.bind(this)
    this.scheduleOrder = this.scheduleOrder.bind(this)
    this.onRechargeConfirm = this.onRechargeConfirm.bind(this)

    props.clearRedux()

    if (props.location.state && props.location.state.mobileRecharge) {
      this.state = props.location.state.mobileRecharge
      props.history.replace({ state: null })
    } else {
      this.state = {
        operatorKey: '',
        areaCode: '',
        creditValue: '',
        pointsValue: '',
        rechargeValue: '',
        schedule: false,
        phoneNumber: '',
        showTerms: false,
        acceptTerms: false,
        innitialDate: null,
        endDate: null,
        rechargeConfirmation: false
      }
    }
  }

  onRechargeConfirm () {
    this.props.clearRedux()
    this.setState({
      ...this.state,
      rechargeConfirmation: true
    })
  }

  onSelectOperatorChange (e) {
    this.setState({
      operatorKey: e.target.value,
      areaCode: '',
      creditValue: '',
      pointsValue: '',
      rechargeValue: '',
      acceptTerms: false
    })
  }

  onChangeAreaCode (e) {
    this.setState({
      areaCode: e.areaCode,
      creditValue: '',
      pointsValue: '',
      rechargeValue: '',
      acceptTerms: false
    })
  }

  onChangeCreditValue (e) {
    this.setState({
      creditValue: e.value,
      pointsValue: e.pointsValue,
      rechargeValue: e.rechargeValue,
      acceptTerms: false
    })
  }

  onChangePhoneNumber (e) {
    this.setState({ phoneNumber: e.phoneNumber })
  }

  showTerms (e) {
    this.setState({ showTerms: true })
  }

  acceptTerms (accept) {
    this.setState({ acceptTerms: accept })
  }

  onChangeScheduleOrder (e) {
    this.setState({ schedule: e.target.checked, acceptTerms: false })
  }

  finalizeOrder () {
    this.props.insertMobileRecharge(
      this.state.creditValue,
      this.state.operatorKey,
      this.state.areaCode,
      this.state.phoneNumber
    )
  }

  scheduleOrder () {
    this.props.scheduleMobileRecharges(
      this.state.creditValue,
      this.state.operatorKey,
      this.state.areaCode,
      this.state.phoneNumber,
      this.state.innitialDate,
      this.state.endDate,
      this.state.rechargeValue,
      this.state.pointsValue
    )
  }

  clearErrorMessage () {
    this.props.clearErrorMessage()
  }

  onChangeEndDate (date) {
    this.setState({ endDate: date })
  }
  onChangeInnitialDate (date) {
    this.setState({ innitialDate: date })
  }

  toogleModal () {
    this.props.closeSecondFactorModal()
  }

  ShowConfirmationModelrecharge () {
    this.setState({ rechargeConfirmation: false })
  }

  componentDidUpdate (prevProsp, props) {
    if (prevProsp.errorMessage !== this.props.errorMessage) {
      if (this.props.errorMessage && this.props.errorMessage.message !== '') {
        this.ShowConfirmationModelrecharge()
      }
    }
  }

  render () {
    var body = []
    var errorMessage = ''
    if (this.props.errorMessage) {
      errorMessage = this.props.errorMessage.subMessage || 'Agradecemos a compreensão.'
    }

    var titleError =
      (this.props.authorizeWithTokenData &&
        this.props.authorizeWithTokenData.titleError) ||
        (this.props.errorMessage ? this.props.errorMessage.message : '')
    if (this.props.authorizeWithTokenData) {
      if (this.props.authorizeWithTokenData.authorized) {
        this.props.closeSecondFactorModal()
        this.props.redirectConfirmation(
          this.props.secondFactorAuthenticationOrderId
        )
      } else if (
        (this.props.authorizeWithTokenData.secondFactorAuthSuccess &&
          this.props.authorizeWithTokenData.hasError) ||
        this.props.authorizeWithTokenData.status === 'TokenFinished'
      ) {
        this.props.closeSecondFactorModal()
        errorMessage =
          this.props.authorizeWithTokenData.messageError ||
          'Não foi possível concluir o seu pagamento. Tentativas de verificação de token excedidas.'
        if (this.state.rechargeConfirmation) {
          this.setState({ rechargeConfirmation: false })
        }
      }
    }

    if (this.state.operatorKey !== '') {
      body.push(
        <div className='col-md-auto col-lg-12 border-dotted-top color-ui-3 px-0 col-12'>
          <div className='txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left mt-2'>
            Digite seu telefone
          </div>
        </div>
      )
      body.push(
        <PhoneNumber
          operatorKey={this.state && this.state.operatorKey}
          onChangeAreaCode={this.onChangeAreaCode}
          onChangePhoneNumber={this.onChangePhoneNumber}
          areaCode={this.state.areaCode}
          phoneNumber={this.state.phoneNumber}
          divContentClassName='col-md-12 col-lg-6 form-field mt-1 px-0'
          required
        />
      )
      if (this.state.areaCode !== '') {
        body.push(<div className='col-12 border-dotted-top color-ui-3 mt-2' />)
        body.push(
          <ValuesRecharge
            onChangeValue={this.onChangeCreditValue}
            valueSelected={this.state && this.state.creditValue}
            areaCode={this.state && this.state.areaCode}
            operatorKey={this.state && this.state.operatorKey}
          />
        )
        if (
          yn(process.env.REACT_APP_HAS_SCHEDULING) &&
          this.state.creditValue
        ) {
          body.push(
            <ScheduleRecharge
              innitialDate={this.state.innitialDate}
              endDate={this.state.endDate}
              onChangeEndDate={this.onChangeEndDate}
              onChangeInnitialDate={this.onChangeInnitialDate}
              maxQuantityMonths={24}
              onChangeScheduleOrder={this.onChangeScheduleOrder}
              scheduleOrder={this.state.schedule}
            />
          )
        }
      }
    }

    var modalRechargeConfirm = (
      <div className='modalConfirmationVoucher'>
        <ModalConfirmRecharge
          onClose={e => this.setState({ rechargeConfirmation: false })}
          show={this.state.rechargeConfirmation}
          areaCode={this.state.areaCode}
          phoneNumber={this.state.phoneNumber}
          creditValue={this.state.rechargeValue}
          finalizeOrder={this.finalizeOrder}
          loadingFinalizeOrder={this.props.loadingFinalizeOrder}
        />
      </div>
    )

    var modalTerms = this.state.schedule ? (
      <ModalTerms
        show={this.state.showTerms}
        onClose={e => this.setState({ showTerms: false })}
        acceptTerms={e => {
          this.setState({
            showTerms: false
          })
          this.acceptTerms(true)
        }}
        terms={{
          vendorId: constants.VENDORID_CELLPHONE_RECHARGE,
          type: constants.REGULATION_TYPE_CAMPAIGN_AND_VENDOR,
          regulationType: constants.REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE
        }}
      />
    ) : (
      <ModalTerms
        show={this.state.showTerms}
        onClose={e => this.setState({ showTerms: false })}
        acceptTerms={e => {
          this.setState({
            showTerms: false
          })
          this.acceptTerms(true)
        }}
        terms={{
          vendorId: constants.VENDORID_CELLPHONE_RECHARGE,
          type: constants.REGULATION_TYPE_VENDOR
        }}
      />
    )

    return (
      <Fragment>
        <Helmet>
          <title>{`Recarga de celular - ${process.env.REACT_APP_TITLE ||
            ''}`}</title>
        </Helmet>
        <ReactPlaceholder
          ready
          customPlaceholder={<CellphonerechargePlaceholder />}
        >
          <div className='container py-0 py-md-5'>

            <AlertErrorMessage
              errorMessage={errorMessage}
              filledState={this.clearErrorMessage}
              title={titleError}
            />

            <div className='row'>
              <div className='col-md-8 col-lg-8 pl-0 pr-0 pr-md-2 pr-lg-2 py-0 h-100'>
                <div className='border-ui-3 radius bg-white md-mb-3'>
                  <div className='col-12 py-3 pb-1 border-color-ui-3 border-bottom bg-recharge'>
                    <h3 className='h3 color-brand-5 col-12 my-3'>
                      Recarga de celular
                    </h3>
                  </div>
                  <div className=' px-3 pb-2'>
                    <div className='col-12 pb-1 border-color-ui-3 py-1'>
                      <SelectOperator
                        checkedValue={this.state.operatorKey}
                        onChangeValue={this.onSelectOperatorChange}
                      />
                    </div>
                    {body}
                  </div>
                </div>
              </div>
              <ResumeRecharge
                operator={this.state.operatorKey}
                areaCode={this.state.areaCode}
                phoneNumber={this.state.phoneNumber}
                creditValue={this.state.rechargeValue}
                pointsValue={this.state.pointsValue}
                scheduleOrder={this.scheduleOrder}
                onRechargeConfirm={this.onRechargeConfirm}
                scheduled={this.state.schedule}
                showTerms={this.showTerms}
                acceptedTerm={
                  (!yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) ||
                    this.state.acceptTerms) &&
                  this.state.operatorKey &&
                  this.state.phoneNumber &&
                  this.state.phoneNumber.indexOf('_') === -1 &&
                  this.state.phoneNumber.trim().length === 10 &&
                  this.state.pointsValue &&
                  (!this.schedule ||
                    (this.state.innitialDate && this.state.endDate))
                }
                onChangeAcceptTerms={this.acceptTerms}
                loadingScheduleOrder={this.props.loadingScheduleOrder}
              />
            </div>
            <div>{modalTerms}</div>
            <div>{modalRechargeConfirm}</div>
          </div>
        </ReactPlaceholder>
        {this.props.secondFactorAuthentication && (
          <div className='modalConfirmationVoucher'>
            <SecondFactorAuthentication
              show
              onClose={() => this.toogleModal()}
              paymentSelected='POINTS_ONLY'
              paymentPoints={null}
              oidc={this.props.oidc}
              confirmedOrderId={this.props.secondFactorAuthenticationOrderId}
              closeModal={this.props.closeSecondFactorModal}
              authorizeWithTokenResend={this.props.authorizeWithTokenResend}
              authorizeWithToken={this.props.authorizeWithToken}
              loadingResendToken={
                this.props.authorizeWithTokenData &&
                this.props.authorizeWithTokenData.loadingResendToken
              }
              isCreatingPurchase={
                this.props.authorizeWithTokenData &&
                this.props.authorizeWithTokenData.isCreatingPurchase
              }
              errorToken={this.props.authorizeWithTokenData && this.props.authorizeWithTokenData.errorToken}
              secondFactorAuthConfirmated={
                this.props.secondFactorAuthConfirmated
              }
              phone={this.props.phone}
            />
          </div>
        )}
      </Fragment>
    )
  }
}

Cellphonerecharge.propTypes = {
  insertMobileRecharge: PropTypes.func,
  clearErrorMessage: PropTypes.func,
  errorMessage: PropTypes.object,
  loadingScheduleOrder: PropTypes.bool,
  loadingFinalizeOrder: PropTypes.bool,
  scheduleMobileRecharges: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
  oidc: PropTypes.object,
  secondFactorAuthentication: PropTypes.bool,
  secondFactorAuthenticationOrderId: PropTypes.number,
  closeSecondFactorModal: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithToken: PropTypes.func,
  authorizeWithTokenData: PropTypes.object,
  redirectConfirmation: PropTypes.func,
  clearRedux: PropTypes.func,
  secondFactorAuthConfirmated: PropTypes.bool,
  phone: PropTypes.string
}

export default Cellphonerecharge



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/Cellphonerecharge.js